export default __webpack_public_path__ + "static/lalibrairie-c-desktop-d649296a7b0c91dc4f96aa5d1128e3fd.jpg";